// import React from 'react';
// import { Route, Switch, Redirect } from "react-router-dom";
// import { connect } from "react-redux";
// import { setCurrentUser } from "../../redux/user/user.actions";

// function AuthenticatedRoute({ component: C, appProps,isAuth, ...rest }) {
//     return (
//       <Route
//         {...rest}
//         render={props =>
//           isAuth
//             ? <C {...props} {...appProps} />
//             : <Redirect
//                 to={`/login?redirect=${props.location.pathname}${props.location.search}`}
//               />}
//       />
//     );
// }

// const mapStateToProps = (state) => ({
//     currentUser: state.user.currentUser,
//     isAuth: state.user.isAuth,
//   });
//   const mapDispatchToProps = (dispatch) => ({
//     setCurrentUser: (user) => dispatch(setCurrentUser(user)),
//   });
//   export default connect(mapStateToProps, mapDispatchToProps)(AuthenticatedRoute);

// import React from "react";
// import { Route, Redirect } from "react-router-dom";

// export default function SafeRoute({ component: Component, ...rest }) {
//   const token = localStorage.getItem("token");
//   const isGuest = localStorage.getItem("is_guest");

//   return (
//     <Route
//       {...rest}
//       render={(props) =>
//         token || isGuest ? (
//           <Component {...props} />
//         ) : (
//           <Redirect to="/login" />
//         )
//       }
//     />
//   );
// }

import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useSelector } from "react-redux";

export default function SafeRoute({ component: Component, ...rest }) {
  return (
    <Route
      {...rest}
      render={(props) => {
        const token = localStorage.getItem("token");
        const isGuest = localStorage.getItem("is_guest") === "true";

        console.log("🛡️ SafeRoute Check:", {
          path: props.location.pathname,
          token,
          isGuest,
        });

        if (token || isGuest) {
          console.log("✅ Allowed:", props.location.pathname);
          return <Component {...props} />;
        }

        console.log("❌ Redirecting to login from:",props.location.pathname);
        return <Redirect to="/login" />;
      }}
    />
  );
}
